import type { Template } from "@/types";

export const PO_03_H3_V0: Template[] = [
{
    id: "po-03-h3v0-01",
    name: "PO 01 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 50, y: 300, width: 340, height: 255, rotation: 0, imageRotation: 0 },
            { id: "2", x: 398, y: 300, width: 340, height: 255, rotation: 0, imageRotation: 0 },
            { id: "3", x: 746, y: 300, width: 340, height: 255, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-03-h3v0-02",
    name: "PO 02 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 287, width: 374, height: 281, rotation: 0, imageRotation: 0 },
        { id: "2", x: 382, y: 287, width: 373, height: 281, rotation: 0, imageRotation: 0 },
        { id: "3", x: 763, y: 287, width: 373, height: 281, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-03",
    name: "PO 03 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_03.png",
    size: [1136, 854],
    style: {},
    slots: [  
        { id: "1", x: 59, y: 85, width: 451, height: 338, rotation: 0, imageRotation: 0 },
        { id: "2", x: 59, y: 431, width: 451, height: 337, rotation: 0, imageRotation: 0 },
        { id: "3", x: 626, y: 258, width: 451, height: 337, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-04",
    name: "PO 04 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 59, y: 85, width: 451, height: 338, rotation: 0, imageRotation: 0 },
        { id: "2", x: 59, y: 431, width: 451, height: 337, rotation: 0, imageRotation: 0 },
        { id: "3", x: 568, y: 215, width: 568, height: 422, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-05",
    name: "PO 05 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_05.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 93, y: 170, width: 313, height: 254, rotation: 0, imageRotation: 0 },
        { id: "2", x: 93, y: 432, width: 313, height: 253, rotation: 0, imageRotation: 0 },
        { id: "3", x: 414, y: 170, width: 630, height: 515, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-06",
    name: "PO 06 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 252, y: 97, width: 632, height: 409, rotation: 0, imageRotation: 0 },
        { id: "2", x: 252, y: 514, width: 312, height: 243, rotation: 0, imageRotation: 0 },
        { id: "3", x: 572, y: 514, width: 312, height: 243, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-07",
    name: "PO 07 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_07.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 0, y: 120, width: 337, height: 302, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 430, width: 337, height: 302, rotation: 0, imageRotation: 0 },
        { id: "3", x: 345, y: 120, width: 791, height: 612, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-08",
    name: "PO 08 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_08.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 53, y: 149, width: 304, height: 274, rotation: 0, imageRotation: 0 },
        { id: "2", x: 53, y: 431, width: 304, height: 273, rotation: 0, imageRotation: 0 },
        { id: "3", x: 365, y: 149, width: 718, height: 555, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-09",
    name: "PO 09 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 103, y: 186, width: 652, height: 483, rotation: 0, imageRotation: 0 },
        { id: "2", x: 763, y: 186, width: 270, height: 238, rotation: 0, imageRotation: 0 },
        { id: "3", x: 763, y: 432, width: 270, height: 237, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h3v0-10",
    name: "PO 10 - H3V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h3_v0_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 60, y: 258, width: 451, height: 337, rotation: 0, imageRotation: 0 },
        { id: "2", x: 627, y: 85, width: 451, height: 338, rotation: 0, imageRotation: 0 },
        { id: "3", x: 627, y: 431, width: 451, height: 337, rotation: 0, imageRotation: 0 }
    ],
}
];